export const MAX_PLAYER = 20;
export const MAX_SPLIT = 2;
export const MAX_HAND = MAX_PLAYER * MAX_SPLIT;
export const MAX_BLACKJACK_HAND = 22;
